import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar"; // ✅ official replacement
import SideNavigation from "./SideNavigation";
import HeaderContext from "../contexts/HeaderContext";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: { display: "flex" },
  toolbar: { paddingRight: 24 },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    // ❌ removed theme.mixins.toolbar (not available in v5)
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: { marginRight: 36 },
  menuButtonHidden: { display: "none" },
  title: { flexGrow: 1 },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: { width: theme.spacing(9) },
  },
  // ❌ removed appBarSpacer
  content: { flexGrow: 1, height: "100vh", overflow: "auto" },
  container: { paddingTop: theme.spacing(4), paddingBottom: theme.spacing(4) },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: { height: 240 },
}));

export default function Dashboard({ children }) {
  const classes = useStyles();
  const [header, setHeader] = useState();

  return (
    <HeaderContext.Provider value={{ header, setHeader }}>
      <div className={classes.root}>
        <CssBaseline />
        <SideNavigation headerTitle={header} />
        <main className={classes.content}>
          <Toolbar />
          {children} {/* instead of <Outlet /> */}
        </main>
      </div>
    </HeaderContext.Provider>
  );
}
